<template>
  <div>
    <div class="container has-text-centered">
      <div class="tile is-ancestor">
        <div class="tile is-parent is-vertical">
          <div class="tile is-child box">
            <div class="columns">
              <div class="column is-6">
                <div id="summary"></div>
              </div>
              <div class="column is-6">
                <div id="net"></div>
              </div>
            </div>
          </div>
          <div class="tile is-child box">
            <div id="networth"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Plotly from "plotly.js-dist";

export default {
  name: "Visualize",
  props: {
    total_income: Number,
    total_expenses: Number,
    total_savings: Number,
    total_future: Number,
    monthly_net_current: Number,
    monthly_net_future: Number,
    future_items: Array,
    income_items: Array,
    expense_items: Array,
    savings_items: Array,
  },
  data() {
    return {
      max_months: 36,
    };
  },
  methods: {
    drawSummary() {
      let trace_data = [];
      let trace_data_b = [];

      const groups = {
        Income: this.income_items,
        Expenses: this.expense_items,
        "Future Items": this.future_items,
      };

      for (const item in groups) {
        for (const itm in groups[item]) {
          let trace = {
            x: [item],
            y: [Number(groups[item][itm].amount)],
            //name: String(groups[item][itm].name),
            name: "",
            text: String(groups[item][itm].name),
            type: "bar",
            hoverinfo: "y+text",
          };
          trace_data.push(trace);
        }
      }

      const summary = {
        "Current Monthly Net": this.monthly_net_current,
        "Future Monthly Net": this.monthly_net_future,
      };
      for (const property in summary) {
        let trace = {
          x: [String(property)],
          y: [summary[property]],
          //name: String(property),
          name: "",
          text: String(property),
          type: "bar",
        };
        trace_data_b.push(trace);
      }

      let layout = {
        barmode: "relative", //stack
        title: "Monthly Summary",
        showlegend: false,
        hovermode: "closest",
        colorway: [
          "#8dd3c7",
          "#ffffb3",
          "#bebada",
          "#fb8072",
          "#80b1d3",
          "#fdb462",
        ],
      };
      let layout_b = {
        barmode: "group",
        title: "Current and Future Monthly Net",
        showlegend: false,
        colorway: [
          "#8dd3c7",
          "#ffffb3",
          "#bebada",
          "#fb8072",
          "#80b1d3",
          "#fdb462",
        ],
      };
      const config = { displayModeBar: false, responsive: true };

      Plotly.newPlot("summary", trace_data, layout, config);
      Plotly.newPlot("net", trace_data_b, layout_b, config);
    },
    drawTimeline() {
      let chart_data = [];
      let trace = {
        x: [],
        y: [],
        name: "Net Worth",
        mode: "lines",
        text: [],
        line: {
          color: "#80b1d3",
        },
        hoverinfo: "text+y",
      };

      if (this.future_items.length > 0) {
        if (this.monthly_net_future > 0) {
          //handle situations where the future is positive
          console.log("it is");

          let end_month = Math.max(
            parseInt(this.future_items[this.future_items.length - 1].month) + 3,
            this.max_months
          );

          this.future_items.forEach((item) => {
            console.log(item);
          });
          // create an increasing savings trace
          for (let mo = 1; mo < end_month; mo++) {
            // add recurring future values
            let future_value = 0;
            this.future_items.forEach((item) => {
              if (mo >= item.month) {
                let multiplier = mo - item.month + 1;
                future_value += item.amount * multiplier;
              }
            });
            // console.log(
            //   mo,
            //   this.total_savings,
            //   this.monthly_net_current,
            //   future_value
            // );
            let new_savings =
              this.total_savings + this.monthly_net_current * mo + future_value;
            trace["x"].push(mo);
            trace["y"].push(new_savings);
            trace["text"].push("Month " + String(mo));
          }
        } else {
          console.log("bummer");
          // calculate the zero month, only show six months beyond that
          let running_savings = this.total_savings;
          let zero_month = 0;
          if (this.running_savings < 0) {
            zero_month = 1;
          } else {
            let breakpoint = 0;
            while (running_savings > 0) {
              zero_month += 1;

              let n_month_future_value = 0;
              this.future_items.forEach((item) => {
                if (zero_month >= item.month) {
                  n_month_future_value += item.amount;
                }
              });
              running_savings +=
                this.monthly_net_current + n_month_future_value;

              breakpoint += 1;
              if (breakpoint >= this.max_months) {
                break;
              }
            }
          }

          let plot_savings = this.total_savings;
          for (let mo = 1; mo <= zero_month + 6; mo++) {
            let future_value = 0;
            this.future_items.forEach((item) => {
              if (mo >= item.month) {
                future_value += item.amount;
              }
            });
            plot_savings += this.monthly_net_current + future_value;
            trace["x"].push(mo);
            trace["y"].push(plot_savings);
            trace["text"].push("Month " + String(mo));
          }
        }
      } else {
        if (this.monthly_net_current > 0) {
          // create an increasing savings chart
          for (let mo = 1; mo < this.max_months; mo++) {
            let new_savings =
              this.total_savings + this.monthly_net_current * mo;
            trace["x"].push(mo);
            trace["y"].push(new_savings);
            trace["text"].push("Month " + String(mo));
          }
        } else {
          // create a chart for the zero month + 6 months
          let zero_month = Math.round(
            this.total_savings / Math.abs(this.monthly_net_current)
          );
          for (let mo = 1; mo <= zero_month + 6; mo++) {
            let new_savings =
              this.total_savings + this.monthly_net_current * mo;
            trace["x"].push(mo);
            trace["y"].push(new_savings);
            trace["text"].push("Month " + String(mo));
          }
        }
      }
      chart_data.push(trace);
      const layout = {
        title: "Estimated Net Worth By Month",
        hovermode: "closest",
      };
      const config = { displayModeBar: false, responsive: true };
      Plotly.newPlot("networth", chart_data, layout, config);
    },
  },
  computed: {
    // monthly_net_current: function () {
    //   let monthly_net_current = this.total_income - this.total_expenses;
    //   return monthly_net_current;
    // },
    // monthly_net_future: function () {
    //   let monthly_net_future =
    //     this.total_income - this.total_expenses + this.total_future;
    //   // console.log(monthly_net_future, this.total_future);
    //   return monthly_net_future;
    // },
  },
  mounted: function () {
    this.drawSummary();
    this.drawTimeline();
  },
  updated: function () {
    this.drawSummary();
    this.drawTimeline();
  },
};
</script>

<style>
</style>